import { __decorate } from "tslib";
import { Pipe } from '@angular/core';
import { formatDate } from '@angular/common';
let DynamicFormatPipe = class DynamicFormatPipe {
    transform(value, pipe, options) {
        if (!value) {
            return value;
        }
        let result = value;
        switch (pipe) {
            case 'date':
                result = formatDate(value, options?.format || 'short', navigator.language, options?.timezone);
                break;
            default:
                break;
        }
        return result;
    }
};
DynamicFormatPipe = __decorate([
    Pipe({
        name: 'dynamicFormat',
        standalone: true,
    })
], DynamicFormatPipe);
export { DynamicFormatPipe };
